export default __webpack_public_path__ + "static/media/bandeira-do-brasil.5354401d.svg";